/** Sổ tay nhân viên — tab soạn thảo cho HR (/growth/site-content) và trang đọc (/handbook). */
export const employeeHandbook: Record<string, string> = {
  'nav.handbook': 'Sổ tay nhân viên',

  // ---- trang đọc ----
  'handbook.title': 'Sổ tay nhân viên',
  'handbook.version': 'Bản {v}',
  'handbook.publishedAt': 'Phát hành {d}',
  'handbook.empty': '{doc} chưa được phát hành. HR sẽ thông báo khi có bản đầu tiên.',
  'handbook.contents': 'Mục lục',
  'handbook.ackButton': 'Tôi đã đọc sổ tay',
  'handbook.ackDone': 'Bạn đã xác nhận đọc bản này.',
  'handbook.quiz.cta.lead': 'Bước tiếp theo: bài kiểm tra {n} câu — đạt từ {score} điểm có quà từ HR.',
  'handbook.quiz.cta.start': 'Làm bài kiểm tra',
  'handbook.quiz.cta.continue': 'Tiếp tục bài kiểm tra',
  'handbook.quiz.cta.result': 'Xem kết quả bài kiểm tra',
  'handbook.quiz.cta.afterAck': 'Sau khi xác nhận, bạn sẽ làm bài kiểm tra {n} câu — đạt từ {score} điểm có quà từ HR.',
  'handbook.ackPending': 'Bạn chưa xác nhận đã đọc bản {v}.',
  'handbook.ackError': 'Không ghi nhận được xác nhận. Thử lại giúp tôi.',
  'handbook.readFromStart': 'Xem lại từ đầu',
  'handbook.previewBanner': 'XEM THỬ BẢN NHÁP — chỉ HR/admin thấy trang này. Nhân viên chưa thấy gì cho tới khi bấm Phát hành.',
  'handbook.previewVersion': 'Bản nháp (chưa phát hành)',
  'handbook.popup.bodyFirst': 'Đây là lần đầu bạn mở sổ tay. Đọc theo từng bước, khoảng 50 phút, dừng lúc nào cũng được.',
  'handbook.popup.readFirst': 'Bắt đầu đọc',
  'handbook.start.progress': 'Bước {n}/{total} · đã đọc {pct}%',
  'handbook.start.progressDone': 'Đã đi hết · 100%',
  'handbook.start.next': 'Tiếp theo',
  'handbook.start.back': 'Quay lại',
  'handbook.start.closingTitle': 'Bạn đã đi hết sổ tay',
  'handbook.start.closingBody': 'Sau khi xác nhận, bạn vẫn mở lại sổ tay bất cứ lúc nào từ menu tài khoản.',
  'handbook.start.agree': 'Tôi đã đọc và đồng ý với nội dung sổ tay nhân viên.',
  'handbook.start.finish': 'Hoàn tất',
  'handbook.start.previewNoAck': 'Chế độ xem thử: chưa có bản phát hành nào để xác nhận, nên nút này tắt.',
  'handbook.start.nothingToConfirm': 'Bản này không yêu cầu xác nhận. Bạn không cần làm gì thêm.',

  // ---- popup nhắc ----
  'handbook.popup.title': 'Sổ tay nhân viên có bản mới',
  'handbook.gate.banner': 'Bạn cần đọc hết sổ tay, xác nhận và nộp bài kiểm tra trước khi dùng các trang khác của system.',
  'handbook.popup.body': 'Bạn chưa xác nhận đã đọc bản {v}. Đọc khi bạn tiện, việc này không chặn gì cả.',
  'handbook.popup.read': 'Đọc ngay',

  // ---- tab HR ----
  'siteContent.tabs.handbook': 'Sổ tay',
  'siteContent.tabs.travelExpense': 'Công tác phí',
  'travelExpense.title': 'Quy định công tác phí',
  'nav.travelExpense': 'Công tác phí',
  'handbook.quiz.openButton': 'Tạo bài kiểm tra',
  'handbook.quiz.title': 'Tạo bài kiểm tra cho bản v{v}?',
  'handbook.quiz.existing': 'Bản này đã có bài kiểm tra: mỗi người {n} câu, đạt từ {score} điểm.',
  'handbook.quiz.categories': 'Bộ câu hỏi',
  'handbook.quiz.noCategories': 'Ngân hàng chưa có câu trắc nghiệm nào.',
  'handbook.quiz.poolSize': 'Ngân hàng của đề: {n} câu',
  'handbook.quiz.drawCount': 'Số câu mỗi người',
  'handbook.quiz.passScore': 'Đạt từ (điểm)',
  'handbook.quiz.duration': 'Thời lượng (phút)',
  'handbook.quiz.hint': 'Mỗi người bốc một bộ câu khác nhau từ ngân hàng, mỗi câu 1 điểm. Đề tự hiện trong "Bài thi của tôi" cho toàn bộ nhân viên. Kết quả và danh sách đạt xem ở Quản lý thi → Kết quả; nút Xuất CSV có cột Đạt.',
  'handbook.quiz.create': 'Tạo bài kiểm tra',
  'handbook.quiz.skip': 'Không, để sau',
  'handbook.quiz.created': 'Đã tạo bài kiểm tra cho bản v{v}. Nhân viên có thể làm ngay.',
  'handbook.quiz.alreadyExisted': 'Bản v{v} đã có bài kiểm tra từ trước — không tạo thêm.',
  'handbook.quiz.errNoCategory': 'Chọn ít nhất một bộ câu hỏi.',
  'handbook.quiz.errDrawMin': 'Số câu phải từ 1 trở lên.',
  'handbook.quiz.errDrawMax': 'Ngân hàng chỉ có {n} câu.',
  'handbook.quiz.errPassRange': 'Ngưỡng đạt không được âm.',
  'handbook.hr.draftHint': 'Lưu là lưu bản nháp. Nhân viên chỉ thấy sau khi bấm Phát hành.',
  'handbook.hr.unpublished': 'Bản nháp đang khác bản đã phát hành.',
  'handbook.hr.published': 'Bản nháp trùng bản đã phát hành.',
  'handbook.hr.noRelease': 'Chưa phát hành lần nào.',
  'handbook.hr.addChapter': 'Thêm chương',
  'handbook.hr.addSection': 'Thêm mục',
  'handbook.hr.chapterTitle': 'Tên chương',
  'handbook.hr.sectionNo': 'Số mục',
  'handbook.hr.sectionTitle': 'Tên mục',
  'handbook.hr.save': 'Lưu nháp',
  'handbook.hr.cancel': 'Huỷ',
  'handbook.hr.edit': 'Sửa',
  'handbook.hr.delete': 'Xoá',
  'handbook.hr.moveUp': 'Lên',
  'handbook.hr.moveDown': 'Xuống',
  'handbook.hr.confirmDeleteSection': 'Xoá mục này? Không khôi phục được.',
  'handbook.hr.confirmDeleteChapter': 'Xoá chương này và TẤT CẢ mục bên trong? Không khôi phục được.',
  'handbook.hr.tableHint':
    'Ô bảng gõ trực tiếp được, nhưng thêm/bớt dòng bảng phải mở nút HTML trên thanh công cụ.',

  // ---- phát hành ----
  'handbook.hr.previewRead': 'Xem thử',
  'handbook.hr.previewWalk': 'Xem từng bước',
  'handbook.hr.previewClose': 'Đóng',
  'handbook.hr.publish': 'Phát hành',
  'handbook.hr.publishTitle': 'Phát hành bản mới',
  'handbook.hr.publishNote': 'Ghi chú (nội bộ, nhân viên không thấy)',
  'handbook.hr.requiresAck': 'Bắt mọi người xác nhận đã đọc lại',
  'handbook.hr.requiresAckHint':
    'Bỏ tick khi chỉ sửa chính tả — sẽ không ai bị làm phiền. Tick khi đổi chính sách.',
  'handbook.hr.publishDone': 'Đã phát hành bản {v}.',

  // ---- theo dõi xác nhận ----
  'handbook.hr.ackStatus': 'Ai đã xác nhận',
  'handbook.hr.ackOf': 'Xác nhận cho bản {v}',
  'handbook.hr.ackNone': 'Chưa có bản nào cần xác nhận.',
  'handbook.hr.colName': 'Nhân viên',
  'handbook.hr.colDept': 'Phòng',
  'handbook.hr.colAck': 'Xác nhận',
  'handbook.hr.colStatus': 'Gửi nhắc',
  'handbook.hr.notYet': 'Chưa',
  'handbook.hr.remindSelected': 'Gửi nhắc ({n})',
  'handbook.hr.remindResult': 'Đã ghi vào chuông {inbox} người, đẩy push tới {n} người.',
  'handbook.hr.remindSkipped': 'Bỏ qua {n} người:',
  'handbook.hr.reason.reminded_today': 'Đã nhắc hôm nay',
  'handbook.hr.reason.no_email': 'Không có email',
  'handbook.hr.reason.no_push_subscription': 'Chưa bật thông báo',
  'handbook.hr.reason.push_not_configured': 'Máy chủ chưa cấu hình gửi thông báo',
  'handbook.hr.reason.already_acknowledged': 'Vừa xác nhận xong',
  'handbook.hr.reason.not_an_active_employee': 'Không còn trong danh sách nhân viên',
  'handbook.hr.reason.ok': 'Gửi được',
  'handbook.hr.remindLimitHint': 'Mỗi người tối đa một lần nhắc mỗi ngày.',
}
